import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = { class: "col-xxl-4 col-xl-4 col-sm-12" }
const _hoisted_3 = { class: "card bg-primary bg-opacity-10 border-primary border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "d-flex align-items-center mb-19" }
const _hoisted_6 = { class: "flex-grow-1 ms-2" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "fs-20 mt-1 mb-0 text-default" }
const _hoisted_9 = { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center d-none" }
const _hoisted_10 = { class: "count countnostyle fw-medium ms-0" }
const _hoisted_11 = { class: "col-xxl-4 col-xl-4 col-sm-6" }
const _hoisted_12 = { class: "card bg-success bg-opacity-10 border-success border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_13 = { class: "card-body p-4" }
const _hoisted_14 = { class: "d-flex align-items-center mb-19" }
const _hoisted_15 = { class: "flex-grow-1 ms-2" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "fs-20 mt-1 mb-0 text-default" }
const _hoisted_18 = { class: "col-xxl-4 col-xl-4 col-sm-6" }
const _hoisted_19 = { class: "card bg-danger bg-opacity-10 border-danger border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_20 = { class: "card-body p-4" }
const _hoisted_21 = { class: "d-flex align-items-center mb-19" }
const _hoisted_22 = { class: "flex-grow-1 ms-2" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "fs-20 mt-1 mb-0 text-default" }
const _hoisted_25 = { class: "col-xxl-2 col-xl-2 col-sm-6 d-none" }
const _hoisted_26 = { class: "card bg-primary-div bg-opacity-10 border-primary-div border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_27 = { class: "card-body p-4" }
const _hoisted_28 = { class: "d-flex align-items-center mb-19" }
const _hoisted_29 = { class: "flex-grow-1 ms-2" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "fs-20 mt-1 mb-0 text-default" }


import { t } from '@/utils/i18nHelper';


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "ProjectsOverview",
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
  schedule: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const formatCurrency = (amount: number) => {
  // Se il valore è zero (o molto vicino a zero), forza 0 per evitare -0,00
  const normalizedAmount = Math.abs(amount) < 0.01 ? 0 : amount;

  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(normalizedAmount);
};

return (_ctx: any,_cache: any) => {
  return (__props.schedule && __props.schedule.statistics)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-40 text-primary" }, " calculate ")
                ], -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", {
                    innerHTML: _unref(t)('fr.liquidity.avg_monthly_rate', 'La tua rata mensile con Smart Rate')
                  }, null, 8, _hoisted_7),
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(formatCurrency(__props.schedule.metadata.avgRate)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(__props.schedule.events.length) + " rate", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-40 text-success" }, " savings ")
                ], -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", {
                    innerHTML: _unref(t)('fr.liquidity.total_deposits', 'Totale Versamenti')
                  }, null, 8, _hoisted_16),
                  _createElementVNode("h3", _hoisted_17, _toDisplayString(formatCurrency(__props.schedule.statistics.totalDeposits)), 1)
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center d-none" }, [
                _createElementVNode("span", { class: "fs-12" }, "Projects this month"),
                _createElementVNode("span", { class: "count countnostyle fw-medium ms-0" }, "+5.75%")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-40 text-danger" }, " payments ")
                ], -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("span", {
                    innerHTML: _unref(t)('fr.liquidity.total_payments', 'Totale Pagamenti')
                  }, null, 8, _hoisted_23),
                  _createElementVNode("h3", _hoisted_24, _toDisplayString(formatCurrency(__props.schedule.statistics.totalPayments)), 1)
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center d-none" }, [
                _createElementVNode("span", { class: "fs-12" }, "Projects this month"),
                _createElementVNode("span", { class: "count countnostyle fw-medium ms-0" }, "-15%")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-shrink-0" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined fs-40 text-primary-div" }, " assignment_turned_in ")
                ], -1)),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("span", {
                    innerHTML: _unref(t)('fr.liquidity.final_balance', 'Saldo Finale Previsto')
                  }, null, 8, _hoisted_30),
                  _createElementVNode("h3", _hoisted_31, _toDisplayString(formatCurrency(__props.schedule.statistics.finalBalance)), 1)
                ])
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center d-none" }, [
                _createElementVNode("span", { class: "fs-12" }, "Projects this month"),
                _createElementVNode("span", { class: "count countnostyle fw-medium ms-0" }, "-15%")
              ], -1))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})